import { Button, Descriptions, Drawer, Tag } from "antd";
import useFormattedDate from "hooks/useFormatDate";
import React from "react";
import { getTagStyle } from "./ActionablesTable";

const urgencyColors = { LOW: "default", MEDIUM: "orange", HIGH: "red" };
const statusColors = {
  ACTIVE: "green",
  COMPLETED: "blue",
  EXPIRED: "gray",
  CANCELLED: "red",
};

export default function ViewActionableDrawer({
  open,
  onClose,
  selectedActionable,
}) {
  const { formatDateTime } = useFormattedDate();

  return (
    <Drawer
      title={<span style={{ fontFamily: "Inter" }}>Actionable Details</span>}
      placement="right"
      size={520}
      open={open}
      onClose={onClose}
      styles={{ body: { padding: 16 } }}
      zIndex={9999}
    >
      {selectedActionable && (
        <Descriptions
          column={1}
          size="small"
          style={{ fontFamily: "Inter", fontSize: 12 }}
          bordered
        >
          <Descriptions.Item label="Message">
            {selectedActionable.message}
          </Descriptions.Item>
          <Descriptions.Item label="Type">
            {selectedActionable.actionItemType}
          </Descriptions.Item>
          <Descriptions.Item label="Display">
            {selectedActionable.displayType}
          </Descriptions.Item>
          <Descriptions.Item label="Urgency">
            <Tag style={getTagStyle("urgency", selectedActionable.urgency)}>
              {selectedActionable.urgency}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag style={getTagStyle("status", selectedActionable.status)}>
              {selectedActionable.status}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Screen">
            {selectedActionable.screen}
          </Descriptions.Item>
          <Descriptions.Item label="Deep Link">
            {selectedActionable.deepLink}
          </Descriptions.Item>
          <Descriptions.Item label="Created">
            {formatDateTime(selectedActionable.createdAt)}
          </Descriptions.Item>
        </Descriptions>
      )}
      <Button type="default" style={{ marginTop: 16 }}>
        Cancel Actionable
      </Button>
    </Drawer>
  );
}
